import React, {useEffect, useRef, useState} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import authAPI from '../../../api/authAPI'
import LeadServiceAPI from '../../../api/LeadServiceAPI'
import {toast} from 'react-toastify'

function SettingsProfile() {
  const [image, setImage] = useState<File | null>(null)
  const [companyName, setCompanyName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [website, setWebsite] = useState('')
  const [editing, setEditing] = useState(false)

  const [userData, setUserData] = useState<any>({})
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedImage = e.target.files[0]
      setImage(selectedImage)

      // let data = {
      //   profile_image: selectedImage,
      // }
      // console.log(e.target.files[0])
      let data = new FormData()
      data.append('logo', e.target.files[0])
      if (data) {
        LeadServiceAPI.updateCompanyLogo(data).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    }
  }

  const handleEditImage = () => {
    if (image) {
      setEditing(true)
      setImage(null)
    } else {
      fileInputRef.current?.click()
    }
  }
  const handleRemoveImage = () => {
    setImage(null)
    setEditing(false)
  }
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Perform form submission logic here
    // e.g., send data to the server
    // console.log({
    //   image,
    //   companyName,
    //   email,
    //   phoneNumber,
    //   website,
    // })

    let data = {
      id: userData?.id,
      name: companyName,
      phone: phoneNumber,
      email: email,
      website_url: website,
    }

    // API calling
    LeadServiceAPI.updateCompanyProfile(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          getInfo()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // get info
  const getInfo = () => {
    authAPI.getMyProfile().then((res: any) => {
      if (res?.data?.success) {
        getCompanyDetails(res?.data?.data?.company_id)
      } else {
        setUserData({})
        let user: any = {}
        setCompanyName(user?.name)
        setEmail(user?.email)
        setPhoneNumber(user?.phone)
        setWebsite(user?.website_url)
      }
    })
  }

  // init
  useEffect(() => {
    getInfo()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // get company details
  const getCompanyDetails = (id: number) => {
    LeadServiceAPI.getCompanyDetails(id).then((res: any) => {
      if (res?.data?.success) {
        setUserData({
          ...res?.data?.data,
          image: res?.data?.imageFolderPath + '/' + res?.data?.data?.logo,
        })
        let user = res?.data?.data
        setCompanyName(user?.name)
        setEmail(user?.email)
        setPhoneNumber(user?.phone)
        setWebsite(user?.website_url)
      } else {
        setUserData({})
        let user: any = {}
        setCompanyName(user?.name)
        setEmail(user?.email)
        setPhoneNumber(user?.phone)
        setWebsite(user?.website_url)
      }
    })
  }
  // handle on image error
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = toAbsoluteUrl('/media/icons/profile.png')
  }
  // render
  return (
    <div className='container setting'>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-lg-12 d-flex mb-3'>
            <div className='form-group d-flex'>
              {image ? (
                <div className='d-flex align-items-center'>
                  <img
                    src={URL.createObjectURL(image)}
                    alt='Selected'
                    width='90'
                    height='90'
                    style={{marginRight: 20, borderRadius: '50%'}}
                  />
                  <br />
                  {/* {editing ? ( */}
                  <button
                    type='button'
                    className='btn btn-sm btn-dark mx-2'
                    onClick={handleEditImage}
                    style={{border: '1px solid #181C32'}}
                  >
                    Change Logo
                  </button>
                  {/* ) : ( */}
                  <button
                    type='button'
                    className='btn btn-sm btn-outline-danger text-danger text-hover-white'
                    onClick={handleRemoveImage}
                    style={{border: '1px solid #F64E60'}}
                  >
                    Remove Logo
                  </button>
                  {/* )} */}
                </div>
              ) : (
                <div className='d-flex align-items-center'>
                  <img
                    onError={handleImageError}
                    src={
                      userData?.image ? userData?.image : toAbsoluteUrl('/media/icons/profile.png')
                    }
                    alt='Selected'
                    width='90'
                    height='90'
                    style={{marginRight: 20, borderRadius: '50%'}}
                  />
                  <input
                    type='file'
                    id='image'
                    onChange={handleImageChange}
                    ref={fileInputRef}
                    style={{display: 'none'}}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-primary my-3'
                    onClick={handleEditImage}
                  >
                    {editing ? 'Change Logo' : 'Select Logo'}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className='col-12 mt-5' />
          <div className='col-lg-6 mb-3'>
            <div className='form-group'>
              <label htmlFor='companyName'>Company Name:</label>
              <input
                style={{borderRadius: 16, height: 50}}
                type='text'
                id='companyName'
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                className='form-control'
              />
            </div>
          </div>
          <div className='col-lg-6 mb-3'>
            <div className='form-group'>
              <label htmlFor='email'>Official Email:</label>
              <input
                style={{borderRadius: 16, height: 50}}
                type='email'
                id='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className='form-control'
              />
            </div>
          </div>
          <div className='col-lg-6 mb-3'>
            <div className='form-group'>
              <label htmlFor='phoneNumber'>Phone Number:</label>
              <input
                style={{borderRadius: 16, height: 50}}
                type='tel'
                id='phoneNumber'
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className='form-control'
              />
            </div>
          </div>
          <div className='col-lg-6 mb-3'>
            <div className='form-group'>
              <label htmlFor='website'>Website:</label>
              <input
                style={{borderRadius: 16, height: 50}}
                type='text'
                id='website'
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                className='form-control'
              />
            </div>
          </div>
          <div className='col-lg-6 d-flex align-items-center mt-5'>
            <p style={{color: '#8E8E8E'}}>
              <img src={toAbsoluteUrl('/media/icons/uis_padlock.png')} alt='lock' />
              Your data is safe and protected.
            </p>
          </div>
          <div className='col-lg-6 text-end mt-5'>
            <button type='submit' className='btn btn-primary' style={{borderRadius: 80}}>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default SettingsProfile
